import React, { useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import './IntramuralCalendar.css';
import { intramurals } from '../content';

const IntramuralCalendar = () => {
  const [selectedEvent, setSelectedEvent] = useState(null); // For displaying event details

  return (
    <div style={{ display: 'flex', gap: '2rem', padding: '2rem' }}>

      {/* Calendar Section */}
      <div style={{ flex: 2 }}>
        <FullCalendar
          plugins={[dayGridPlugin]}
          initialView="dayGridMonth"
          events={intramurals}
          height="auto"
          eventClick={(info) => {
            setSelectedEvent({
              title: info.event.title,
              date: info.event.startStr,
              time: info.event.extendedProps.time,
              description: info.event.extendedProps.description,
              link: info.event.extendedProps.link,
            });
          }}
          eventDidMount={(info) => {
            info.el.style.cursor = 'pointer';
          }}
        />
      </div>

      {/* Side Panel for Event Info */}
      <div
        style={{
          flex: 1,
          border: '1px solid #ddd',
          padding: '1rem',
          borderRadius: '8px',
          backgroundColor: '#f9f9f9',
          minHeight: '200px',
        }}
      >
        {selectedEvent ? (
          <>
            <h2>{selectedEvent.title}</h2>
            <p><strong>Date:</strong> {selectedEvent.date}</p>
            <p><strong>Time:</strong> {selectedEvent.time}</p>
            <p><strong>Details:</strong> {selectedEvent.description}</p>
            {selectedEvent.link && (
              <p>
                <a
                  href={selectedEvent.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#2563eb',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                  }}
                >
                  Learn more / RSVP
                </a>
              </p>
            )}
          </>
        ) : (
          <p>Select an event to see details</p>
        )}
      </div>
    </div>
  );
};

export default IntramuralCalendar;
